
export interface StyleFilterData {
  id: string;
  prompt_name: string;
  category: string;
  priority: number;
  tags: string[];
}

export const STYLE_FILTERS: StyleFilterData[] = [
  // Photo styles
  {
    id: "photo-style-portrait",
    prompt_name: "Portrait",
    category: "Photo",
    priority: 100,
    tags: ["portrait", "professional"]
  },
  {
    id: "photo-style-landscape",
    prompt_name: "Landscape",
    category: "Photo", 
    priority: 90,
    tags: ["landscape", "nature"]
  },
  {
    id: "photo-style-street",
    prompt_name: "Street Photography",
    category: "Photo",
    priority: 80,
    tags: ["street", "urban"]
  },
  {
    id: "photo-style-documentary",
    prompt_name: "Documentary",
    category: "Photo",
    priority: 70,
    tags: ["documentary", "journalism"]
  },
  {
    id: "photo-style-fashion",
    prompt_name: "Fashion",
    category: "Photo",
    priority: 60,
    tags: ["fashion", "style"]
  },
  {
    id: "photo-style-macro",
    prompt_name: "Macro",
    category: "Photo",
    priority: 50,
    tags: ["macro", "closeup"]
  },
  {
    id: "photo-style-architectural",
    prompt_name: "Architectural",
    category: "Photo",
    priority: 40,
    tags: ["architecture", "building"]
  },
  {
    id: "photo-style-fine-art",
    prompt_name: "Fine Art",
    category: "Photo",
    priority: 30,
    tags: ["fine art", "artistic"]
  },
  {
    id: "photo-style-cinematic",
    prompt_name: "Cinematic",
    category: "Photo",
    priority: 20,
    tags: ["cinematic", "film"]
  },
  {
    id: "photo-style-vintage",
    prompt_name: "Vintage Film",
    category: "Photo",
    priority: 10,
    tags: ["vintage", "film"]
  },
  
  // Anime styles
  {
    id: "anime-style-studio-ghibli",
    prompt_name: "Studio Ghibli",
    category: "Anime",
    priority: 100,
    tags: ["ghibli", "miyazaki"]
  },
  {
    id: "anime-style-shounen",
    prompt_name: "Shounen",
    category: "Anime",
    priority: 90,
    tags: ["shounen", "action"]
  },
  {
    id: "anime-style-shoujo",
    prompt_name: "Shoujo",
    category: "Anime",
    priority: 80,
    tags: ["shoujo", "romance"]
  },
  {
    id: "anime-style-seinen",
    prompt_name: "Seinen",
    category: "Anime",
    priority: 70,
    tags: ["seinen", "mature"]
  },
  {
    id: "anime-style-moe",
    prompt_name: "Moe",
    category: "Anime",
    priority: 60,
    tags: ["moe", "cute"]
  },
  {
    id: "anime-style-chibi",
    prompt_name: "Chibi",
    category: "Anime",
    priority: 50,
    tags: ["chibi", "cute"]
  },
  {
    id: "anime-style-realistic",
    prompt_name: "Realistic Anime",
    category: "Anime",
    priority: 40,
    tags: ["realistic", "detailed"]
  },
  {
    id: "anime-style-cel-shaded",
    prompt_name: "Cel Shaded",
    category: "Anime",
    priority: 30,
    tags: ["cel shaded", "traditional"]
  },
  {
    id: "anime-style-manga",
    prompt_name: "Manga Style",
    category: "Anime",
    priority: 20,
    tags: ["manga", "comic"]
  },
  {
    id: "anime-style-cyberpunk",
    prompt_name: "Cyberpunk Anime",
    category: "Anime",
    priority: 10,
    tags: ["cyberpunk", "futuristic"]
  },
  
  // Art styles
  {
    id: "art-style-renaissance",
    prompt_name: "Renaissance",
    category: "Art",
    priority: 100,
    tags: ["renaissance", "classical"]
  },
  {
    id: "art-style-impressionist",
    prompt_name: "Impressionist",
    category: "Art",
    priority: 90,
    tags: ["impressionist", "monet"]
  },
  {
    id: "art-style-baroque",
    prompt_name: "Baroque",
    category: "Art",
    priority: 80,
    tags: ["baroque", "dramatic"]
  },
  {
    id: "art-style-art-nouveau",
    prompt_name: "Art Nouveau",
    category: "Art",
    priority: 70,
    tags: ["art nouveau", "decorative"]
  },
  {
    id: "art-style-art-deco",
    prompt_name: "Art Deco",
    category: "Art",
    priority: 60,
    tags: ["art deco", "geometric"]
  },
  {
    id: "art-style-abstract",
    prompt_name: "Abstract",
    category: "Art",
    priority: 50,
    tags: ["abstract", "modern"]
  },
  {
    id: "art-style-cubist",
    prompt_name: "Cubist",
    category: "Art",
    priority: 40,
    tags: ["cubist", "picasso"]
  },
  {
    id: "art-style-surreal",
    prompt_name: "Surreal",
    category: "Art",
    priority: 30,
    tags: ["surreal", "dreamlike"]
  },
  {
    id: "art-style-pop-art",
    prompt_name: "Pop Art",
    category: "Art",
    priority: 20,
    tags: ["pop art", "warhol"]
  },
  {
    id: "art-style-minimalist",
    prompt_name: "Minimalist",
    category: "Art",
    priority: 15,
    tags: ["minimalist", "clean"]
  },
  {
    id: "art-style-watercolor",
    prompt_name: "Watercolor",
    category: "Art",
    priority: 10,
    tags: ["watercolor", "painting"]
  },
  {
    id: "art-style-oil-painting",
    prompt_name: "Oil Painting",
    category: "Art",
    priority: 5,
    tags: ["oil painting", "traditional"]
  },
  {
    id: "art-style-digital-art",
    prompt_name: "Digital Art",
    category: "Art",
    priority: 3,
    tags: ["digital", "modern"]
  },
  {
    id: "art-style-photorealism",
    prompt_name: "Photorealism",
    category: "Art",
    priority: 1,
    tags: ["photorealistic", "detailed"]
  },
  
  // 3D styles
  {
    id: "3d-style-photorealistic",
    prompt_name: "Photorealistic Render",
    category: "3D",
    priority: 100,
    tags: ["photorealistic", "realistic"]
  },
  {
    id: "3d-style-stylized",
    prompt_name: "Stylized",
    category: "3D",
    priority: 90,
    tags: ["stylized", "cartoon"]
  },
  {
    id: "3d-style-cartoon",
    prompt_name: "Cartoon 3D",
    category: "3D",
    priority: 80,
    tags: ["cartoon", "animated"]
  },
  {
    id: "3d-style-low-poly",
    prompt_name: "Low Poly",
    category: "3D",
    priority: 70,
    tags: ["lowpoly", "geometric"]
  },
  {
    id: "3d-style-architectural",
    prompt_name: "Architectural Visualization",
    category: "3D",
    priority: 60,
    tags: ["architectural", "building"]
  },
  {
    id: "3d-style-product",
    prompt_name: "Product Rendering",
    category: "3D",
    priority: 50,
    tags: ["product", "commercial"]
  },
  {
    id: "3d-style-character",
    prompt_name: "Character Modeling",
    category: "3D",
    priority: 40,
    tags: ["character", "model"]
  },
  {
    id: "3d-style-clay",
    prompt_name: "Clay Render",
    category: "3D",
    priority: 30,
    tags: ["clay", "organic"]
  },
  {
    id: "3d-style-glass",
    prompt_name: "Glass Material",
    category: "3D",
    priority: 20,
    tags: ["glass", "transparent"]
  },
  {
    id: "3d-style-metallic",
    prompt_name: "Metallic Render",
    category: "3D",
    priority: 10,
    tags: ["metallic", "metal"]
  }
];
